export const renewalEnTranslation = {
  renewal: {
    steps: {
      choose: "Choose",
      term: "Lease term",
      next: "Next steps",
      moveOut: "Move-out notice",
      of: "Step {{current}} of {{total}}",
      back: "Back",
      continue: "Continue",
      ntvSummary: "Household",
      ntvDetails: "Notice details",
      ntvConfirm: "Confirm",
    },
    choice: {
      title: "Renew or move out",
      subtitle: "Are you renewing, or moving out?",
      renew: "Renew lease",
      renewDescription: "Keep your home and pick a new lease term.",
      moveOut: "Submit notice to vacate",
      moveOutDescription: "Tell us your move-out date and next steps.",
    },
    stub: {
      renewTitle: "Renew lease",
      renewBody:
        "Lease term selection and signing are coming soon. For now, return home or use the renewal request from your property team if you already have instructions.",
      moveOutTitle: "Notice to vacate",
      moveOutBody:
        "Self-service notice to vacate is coming soon. Please contact your property team if you need to give notice today.",
      backHome: "Back to home",
    },
    terms: {
      title: "Choose a lease term",
      subtitle: "Review your approved renewal lease terms and rates.",
      rentOnlyNote:
        "Amounts shown are monthly rent only. Other recurring items are not included in this comparison.",
      months_one: "{{count}} month",
      months_other: "{{count}} months",
      months: "{{count}} months",
      termLabel_one: "{{count}} Month Lease",
      termLabel_other: "{{count}} Month Lease",
      termLabel: "{{count}} Month Lease",
      colTerm: "Select lease term",
      colRent: "Rent",
      colDates: "Lease dates",
      perMonth: "/ mo",
      preferred: "Preferred",
      saving: "Saving…",
      saveError: "We could not save your term. Please try again.",
      continue: "Continue",
      empty:
        "No renewal terms are available yet for your lease. Please contact your property team.",
      nextTitle: "Term selected",
      nextBody:
        "Your term is saved. Updating your household details and signing the renewal are coming next.",
    },
    ntv: {
      summaryTitle: "Review your household",
      summarySubtitle:
        "We already have these details from your lease. Continue to enter your move-out notice.",
      leavingLabel: "On this lease",
      propertyLabel: "Property",
      unitLabel: "Unit",
      leaseEndLabel: "Lease end date",
      detailsTitle: "Notice to vacate",
      detailsSubtitle:
        "Tell us when you are moving out and where we should send final correspondence.",
      moveOutDate: "Desired move-out date",
      noticeHint: "Must be at least {{days}} days from today.",
      allLeaving: "Are all residents leaving?",
      allLeavingYes: "Yes",
      allLeavingNo: "No",
      whoMoving: "Who is moving out?",
      whoMovingHint:
        "Select everyone who is leaving. Leave unchecked anyone staying.",
      reason: "Reason for leaving",
      reasonPlaceholder: "Select a reason",
      forwarding: "Forwarding address",
      forwardingHint: "Required for final account statements.",
      forwardingPlaceholder: "Street, city, state, ZIP",
      reviewTitle: "Confirm your notice",
      reviewSubtitle: "Double-check these details before you submit.",
      submit: "Submit notice",
      submitting: "Submitting…",
      successTitle: "Notice submitted",
      successBody:
        "Your property team has been notified and will update your lease records. You do not need to take further action here.",
      errorGeneric:
        "We could not submit your notice. Please try again or contact your property team.",
      errTooSoon: "Choose a date at least {{days}} days from today.",
      errBlackout:
        "That date is not available for move-out at this property. Pick another day.",
      errInvalidDate: "Enter a valid move-out date.",
      errWhoRequired: "Select at least one resident who is moving out.",
      errWhoAll: "If everyone is leaving, choose Yes above.",
      errReason: "Select a reason for leaving.",
      errForwarding: "Enter a forwarding address.",
      errReasonsEmpty:
        "Leave reasons are unavailable right now. Please try again later or contact your property team.",
    },
    banner: {
      selfServiceLink: "Get started",
    },
    homeStatus: {
      ntvTitle:
        "We're sorry to see you go. You're moving out on {{moveOutDate}}.",
      ntvSecondary:
        "Your property team has been notified. No further action is needed here.",
      renewTitle:
        "You're renewing — {{months}}-month term at {{rent}}/mo ({{dateRange}}).",
      renewContinue: "Continue",
      renewChangeTerm: "Change term",
    },
  },
};
